import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, retryWhen, delay, share } from 'rxjs/operators';

import { API_URL_PREFIX, BasicService } from './basic.service';
import { AlcmeonContextService } from '../../core/alcmeon-context/alcmeon-context.service';
import { MaintenanceModeModalComponent } from 'src/app/shared/components/maintenance-mode-modal/maintenance-mode-modal.component';

const CHECK_INTERVAL_MS = 10000;

@Injectable({
  providedIn: 'root',
})
export class MaintenanceModeService {
  private isMaintenanceFinished$: Observable<void> = null; // null iff maintenance mode is currently off

  constructor(
    private http: HttpClient,
    private alcmeonContext: AlcmeonContextService,
    private basicService: BasicService
  ) {}

  maybeInitMaintenanceModeThenReturnFinishedObservable() {
    this.maybeInitMaintenanceMode();
    return this.isMaintenanceFinished$;
  }

  private maybeInitMaintenanceMode() {
    if (this.isMaintenanceFinished$ === null) {
      this.openModal();
      this.isMaintenanceFinished$ = this.http.get<any>(this.maintenanceCheckUrl()).pipe(
        retryWhen(errors => errors.pipe(delay(CHECK_INTERVAL_MS))),
        tap(() => this.maintenanceDidFinish()),
        share()
      ); // prevent requests waiting in the interceptor (there can be serveral) to trigger parallel checks
    }
  }

  maintenanceCheckUrl() {
    const companyId = this.alcmeonContext.companyId;
    return `${API_URL_PREFIX}/api/1.0/companies/${companyId}/is_maintenance`;
  }

  private maintenanceDidFinish() {
    this.basicService.dismissModal();
    this.isMaintenanceFinished$ = null;
  }

  private openModal() {
    this.basicService.hideSpinner(); // spinner has a higher z-index set by ionic, let's clear it if there is one
    this.basicService.modal(
      {
        component: MaintenanceModeModalComponent,
        cssClass: 'mainenance-mode-modal',
      },
      true
    );
  }
}
